import React, { Component } from 'react';
import { Trans } from "react-i18next";
import {isMobile} from 'react-device-detect';
import ModalVideo from "react-modal-video";
import ReactGA from 'react-ga';

class GripBanner extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false
		};
		this.openModal = this.openModal.bind(this);
	}

	openModal() {
		this.setState({ isOpen: true });

		ReactGA.event({
			category: 'ICAST',
			action: 'PlayVideo'
		});

	}

	render() {
		return (
			<section className="grip-banner">
				<div className="container">
					<div className="row fullscreen d-flex align-items-center justify-content-end">
						<div className="banner-content text-right col-lg-4 col-sm-4 col-md-8">
							<h1>
								<Trans i18nKey="grip.title" />
							</h1>
							<p>
								<Trans i18nKey="grip.desc" />
							</p>
						</div>
					</div>
					<div className="overlay overlay-bg" />
					{isMobile ?
					<div className="row video-popup align-items-center justify-content-center" style={{paddingBottom: '10px'}}>
						<div>
							<button onClick={this.openModal} className="play-video video-play-button animate">
								<span />
							</button>
						</div>
						<p className="watch text-uppercase">Watch FishingGrip Video</p>

						<ModalVideo
							channel="youtube"
							isOpen={this.state.isOpen}
							videoId="SJxxnN5rqpA"
							onClose={() => this.setState({ isOpen: false })}
						/>

					</div>
						: ''}
				</div>

			</section>
		);
	}
}

export default GripBanner;
